import type { FormLabelTranslationsObject } from "../../translation-keys/form-label-keys.js";

const FormLabels: FormLabelTranslationsObject = {
  eclipse_FirstName: "Vorname",
  eclipse_LastName: "Familienname, Nachname",
  eclipse_Email: "Business-E-Mail",
  eclipse_Company: "Firmenname",
  eclipse_Country: "Land",
  eclipse_State: "State",
  eclipse_Phone: "Telefon",
  eclipse_Tier__c: "Unternehmensgröße",
  eclipse_Industry: "Industrie",
  eclipse_Department__c: "Abteilung",
  eclipse_contactRequested: "I want someone to call me.",
  eclipse_Webform_Comments_recent_value__c: "Ihr Anliegen",
  eclipse_Latest_Solution_Interest__c: "Hauptlösungsinteresse",
  eclipse_Email_Opt_In__c: `Ich möchte weitere Informationen zu diesem Thema erhalten und die {privacy-policy-link-slot} gelesen, verstanden und stimme ihr zu.`,
  privacyStatement: "Der Schutz Ihrer Daten ist uns wichtig. In unserer {privacy-policy-link-slot} erfahren Sie, wie wir Daten verarbeiten und schützen.",
  privacyNewsletterOptIn: "By signing up, you agree to receive our marketing emails. Review our {privacy-policy-link-slot} for details on data handling.",
  privacyPolicyLinkText: "Datenschutzbestimmungen",
  eclipse_Entity: "Legal Entity Name",
  eclipse_Partner_Opt_in_Processing__c : "I'd like to receive more information on this topic from the MasterControl Partner(s) affiliated with this event.",
  eclipse_NonBusinessEmail: "Email",
};

export default FormLabels;